import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import {BaseService} from "./base-service";
import {AppConfig} from "../config/appconfig";
import {Observable} from "rxjs";
import { Storage } from '@ionic/storage';

/*
  Generated class for the ZonesService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ZonesService extends BaseService{
  StoreZones(zones: any[]) {
    this.storage.set('zones', zones);
  }

  public readonly zonesUrl: string = AppConfig.apiBaseUrl + "zones";

  constructor(
    public http: Http,
    protected storage: Storage
  ) {
    super(http, storage);
  }

  public async getZones(): Promise<any[]>{
    let url = this.zonesUrl;
    try {
      let response = await this.http.get(url, {headers: this.headers}).toPromise();

      var zones = response.json();

      
      zones.forEach(zone => {
        zone.IsVisible = false;
      });

      await this.storage.get('zones').then((val) => {
        zones.forEach(zone => {
          if(val){
            val.forEach(z => {
              if (z.ZoneId == zone.ZoneId) {
                zone.IsVisible = z.IsVisible;
              }
            });
          }
        });
      });

      return zones;
    }
    catch(e){
      throw e;
    }
  }

  public getZone(id: number): Observable<any[]>{
    let url = this.zonesUrl + "/" + id.toString();
    return this.http.get(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let body = res.json();
        var d = body || {};
        return d;
      });
      //.catch(this.handleError);
  }

  public saveZone(zone: any): Observable<any>{
    if(!zone){
      return new Observable<any>(observer => {
        observer.error(new Error("Не передан объект"));
      });
    }

    let action: Observable<Response>;

    let id: number;
    if(zone !== undefined && zone.ZoneId !== null){
      id = Number(zone.ZoneId);
    }
    if(id !== undefined && id !== null && id > 0){
      // AS: редактируем объект
      action = this.http.put(
        this.zonesUrl + "/" + id,
        zone,
        {headers: this.headers}
      );
    }else{
      // AS: создаем объект
      action = this.http.post(
        this.zonesUrl,
        zone,
        {headers: this.headers}
      );
    }

    return action.map((res: Response) => {
      return this.prepareData(res);
    });
    //   .catch(
    //   (err) => {
    //     return Observable.throw(err);
    //   }
    // );
  }

  // AS: Delete zone
  public deleteZone(id: number): Observable<void>{
    if(!id){
      return new Observable<any>(observer => {
        observer.error(new Error("Не передан объект"));
      });
    }

    let action = this.http.delete(
      this.zonesUrl + "/" + id,
      {headers: this.headers}
    );

    return action.map((res: Response) => {
      return this.prepareData(res);
    });
    //   .catch(
    //   (err) => {
    //     return Observable.throw(err);
    //   }
    // );
  }
}



// WEBPACK FOOTER //
// ./src/providers/zones-service.ts